var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('page-loader'):_c(_vm.questionsComponent,{tag:"component",attrs:{"save-data":_vm.saveData,"on-submit":_vm.onSubmit},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})}
var staticRenderFns = []

export { render, staticRenderFns }